<div class="cart-container container py-5">
    <div class="row mb-4">
        <div class="col-12">
            <h2 class="cart-title">Your Order Cart</h2>
            <p class="text-muted">Review your selected documents before proceeding.</p>
        </div>
    </div>

    @if (cartData(); as data) {
        @if (data.cartItems && data.cartItems.length > 0) {
            <div class="row">
                <div class="col-lg-8 mb-4">
                    <div class="card shadow-sm border-0 rounded-4">
                        <div class="card-body p-0">
                            <div class="table-responsive">
                                <table class="table table-hover align-middle mb-0 cart-table">
                                    <thead class="table-light">
                                        <tr>
                                            <th scope="col" class="ps-4">Document</th>
                                            <th scope="col" class="text-center">Count</th>
                                            <th scope="col" class="text-center">Time</th>
                                            <th scope="col" class="text-end">Fee</th>
                                            <th scope="col" class="text-center pe-4">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @for (item of data.cartItems; track $index) {
                                            <tr>
                                                <td class="ps-4">
                                                     <div class="fw-bold document-name">{{ item.document_name }}</div>
                                                     @if (item.is_expedited) {
                                                         <span class="badge bg-warning text-dark mt-1">Expedited</span>
                                                     }
                                                     <div class="small text-muted mt-1">Expected: {{ item.expected_date }}</div>
                                                </td>
                                                <td class="text-center">
                                                     <span class="count-badge">{{ item.count }}</span>
                                                </td>
                                                <td class="text-center text-muted">
                                                     {{ item.total_time }} days
                                                </td>
                                                <td class="text-end fw-semibold text-primary">
                                                     ${{ item.total_fee }}
                                                </td>
                                                <td class="text-center pe-4">
                                                    <button class="btn btn-link text-danger p-0 border-0" (click)="removeItem(item)" title="Remove item">
                                                        <span style="color: red;" class="material-symbols-outlined">
                                                            delete
                                                        </span>
                                                    </button>
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="card shadow-sm border-0 rounded-4 summary-card">
                        <div class="card-body p-4 pt-0">
                            <h4 class="card-title mb-4 fw-bold border-bottom pb-3">Order Summary</h4>
                            
                            
                            <div class="d-flex justify-content-between mb-3">
                                <span class="text-muted">Max Time:</span>
                                <span class="fw-medium">{{ data.total_time }} days</span>
                            </div>

                            <div class="d-flex justify-content-between mb-4">
                                <span class="text-muted">Expected Date:</span>
                                <span class="fw-medium">{{ data.expected_date }}</span>
                            </div>

                            <div class="d-flex justify-content-between mb-4 pt-3 border-top">
                                <span class="fs-5 fw-bold">Total Fee:</span>
                                <span class="fs-4 fw-bold text-primary">${{ data.total_fee }}</span>
                            </div>

                            <div class="d-grid gap-3 mt-4">
                                <button class="btn btn-primary btn-lg rounded-pill fw-semibold shadow-sm" (click)="moveForward()">
                                    Proceed to Checkout <i class="bi bi-arrow-right ms-2"></i>
                                </button>
                                <button class="btn btn-outline-secondary btn-lg rounded-pill fw-semibold" (click)="goBack()">
                                    <i class="bi bi-arrow-left me-2"></i> Return to Home
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        } @else {
            <div class="text-center py-5">
                <i class="bi bi-cart-x text-muted" style="font-size: 4rem;"></i>
                <h3 class="mt-3">Your cart is empty</h3>
                <p class="text-muted mb-4">You haven't added any documents to your cart yet.</p>
                <button class="btn btn-primary btn-lg rounded-pill px-5" (click)="goBack()">
                    Start an Order
                </button>
            </div>
        }
    } @else {
        <div class="text-center py-5">
            <i class="bi bi-cart-x text-muted" style="font-size: 4rem;"></i>
            <h3 class="mt-3">Your cart is empty</h3>
            <p class="text-muted mb-4">You haven't added any documents to your cart yet.</p>
            <button class="btn btn-primary btn-lg rounded-pill px-5" (click)="goBack()">
                Start an Order
            </button>
        </div>
    }
</div>
